import React from 'react';

import { ToggleStateFilter } from 'components/filters/ToggleStateFilter';

const toggleStates = [
	{
		value: "customer", 
		name: "osfc.filters.type.customer"
	},
	{
		value: "transporter", 
		name: "osfc.filters.type.transporter"
	},
];


export const ToggleTypeFilter = (props) => <ToggleStateFilter {...props} toggleStates={toggleStates} />;
